/* eslint-disable max-len */
import { LANGUAGE_ENGLISH, LANGUAGE_ENGLISH_MURABAHA } from '../../utils/constants';

const IDS = {
  HELMET_CHANGEEMAIL_PAGETITLE_CREATE: 'changeEmail.helmet.create.pageTitle',
  HELMET_CHANGEEMAIL_PAGETITLE_ERROR: 'changeEmail.helmet.error.pageTitle',
  HELMET_CHANGEEMAIL_PAGETITLE_SUCCESS: 'changeEmail.helmet.success.pageTitle',
  HELMET_CHANGEEMAIL_PAGETITLE_VERIFY: 'changeEmail.helmet.verify.pageTitle',
  HELMET_FORGOTPASSWORD_PAGETITLE: 'forgotPassword.helmet.pageTitle',
  HELMET_FORGOTPASSWORD_PAGETITLE_CREATE: 'forgotPassword.helmet.create.pageTitle',
  HELMET_FORGOTPASSWORD_PAGETITLE_EMAILSENT: 'forgotPassword.helmet.emailSent.pageTitle',
  HELMET_FORGOTPASSWORD_PAGETITLE_ERROR: 'forgotPassword.helmet.error.pageTitle',
  HELMET_FORGOTPASSWORD_PAGETITLE_SUCCESS: 'forgotPassword.helmet.success.pageTitle',
  HELMET_FORGOTUSERNAME_PAGETITLE: 'forgotUsername.helmet.pageTitle',
  HELMET_FORGOTUSERNAME_PAGETITLE_EMAILSENT: 'forgotUsername.helmet.emailSent.pageTitle',
  HELMET_FORGOTUSERNAME_PAGETITLE_ERROR: 'forgotUsername.helmet.error.pageTitle',
  HELMET_FORGOTUSERNAME_PAGETITLE_SUCCESS: 'forgotUsername.helmet.success.pageTitle',
  HELMET_FORGOTUSERNAME_PAGETITLE_VERIFY: 'forgotUsername.helmet.verify.pageTitle',
  HELMET_REGISTER_PAGETITLE_CONSENT: 'register.helmet.pageTitle.consent',
  HELMET_REGISTER_PAGETITLE_EMAIL: 'register.helmet.pageTitle.email',
  HELMET_REGISTER_PAGETITLE_ERROR: 'register.helmet.pageTitle.error',
  HELMET_REGISTER_PAGETITLE_LOANNUMBER: 'register.helmet.pageTitle.loanNumber',
  HELMET_REGISTER_PAGETITLE_PREPARINGACCOUNT: 'register.helmet.pageTitle.preparingAccount',
  HELMET_REGISTER_PAGETITLE_RECAPTCHA: 'register.helmet.pageTitle.recaptcha',
  HELMET_REGISTER_PAGETITLE_RESEND: 'register.helmet.pageTitle.resend',
  HELMET_REGISTER_PAGETITLE_SSN: 'register.helmet.pageTitle.ssn',
  HELMET_REGISTER_PAGETITLE_SUCCESS: 'register.helmet.pageTitle.success',
  HELMET_REGISTER_PAGETITLE_USERNAMEPASSWORD: 'register.helmet.pageTitle.usernamePassword',
  HELMET_REGISTER_PAGETITLE_ZIP: 'register.helmet.pageTitle.zip',
  HELMET_SECTIONTITLE_CHANGEEMAIL: 'register.helmet.sectionTitle.changeEmail',
  HELMET_SECTIONTITLE_FORGOTPASSWORD: 'register.helmet.sectionTitle.forgotPassword',
  HELMET_SECTIONTITLE_FORGOTUSERNAME: 'register.helmet.sectionTitle.forgotUsername',
  HELMET_SECTIONTITLE_REGISTER: 'register.helmet.sectionTitle',
};

const enMessages = {
  // Change Email Helmet Page Titles
  [IDS.HELMET_CHANGEEMAIL_PAGETITLE_VERIFY]: 'Verify Loan Information',
  [IDS.HELMET_CHANGEEMAIL_PAGETITLE_CREATE]: 'Create New Email',
  [IDS.HELMET_CHANGEEMAIL_PAGETITLE_ERROR]: 'Error',
  [IDS.HELMET_CHANGEEMAIL_PAGETITLE_SUCCESS]: 'Success',
  // Forgot Password Helmet Page Titles
  [IDS.HELMET_FORGOTPASSWORD_PAGETITLE_CREATE]: 'Create New Password',
  [IDS.HELMET_FORGOTPASSWORD_PAGETITLE_EMAILSENT]: 'Recovery Email Sent',
  [IDS.HELMET_FORGOTPASSWORD_PAGETITLE_ERROR]: 'Error',
  [IDS.HELMET_FORGOTPASSWORD_PAGETITLE_SUCCESS]: 'Success',
  // Forgot Username Helmet Page Titles
  [IDS.HELMET_FORGOTUSERNAME_PAGETITLE_EMAILSENT]: 'Recovery Email Sent',
  [IDS.HELMET_FORGOTUSERNAME_PAGETITLE_ERROR]: 'Error',
  [IDS.HELMET_FORGOTUSERNAME_PAGETITLE_SUCCESS]: 'Success',
  [IDS.HELMET_FORGOTUSERNAME_PAGETITLE_VERIFY]: 'Verify Loan Information',
  // Register Helmet Page Titles
  [IDS.HELMET_REGISTER_PAGETITLE_CONSENT]: 'Policies and Terms of Use',
  [IDS.HELMET_REGISTER_PAGETITLE_EMAIL]: 'Email Address',
  [IDS.HELMET_REGISTER_PAGETITLE_LOANNUMBER]: 'Loan Number',
  [IDS.HELMET_REGISTER_PAGETITLE_ERROR]: 'Error',
  [IDS.HELMET_REGISTER_PAGETITLE_PREPARINGACCOUNT]: 'Preparing Account',
  [IDS.HELMET_REGISTER_PAGETITLE_RECAPTCHA]: 'Recaptcha',
  [IDS.HELMET_REGISTER_PAGETITLE_RESEND]: 'Resend Email',
  [IDS.HELMET_REGISTER_PAGETITLE_SSN]: 'SSN',
  [IDS.HELMET_REGISTER_PAGETITLE_SUCCESS]: 'Success',
  [IDS.HELMET_REGISTER_PAGETITLE_USERNAMEPASSWORD]: 'Create Username/Password',
  [IDS.HELMET_REGISTER_PAGETITLE_ZIP]: 'Zip Code',
  // Register Helmet Section Titles
  [IDS.HELMET_SECTIONTITLE_CHANGEEMAIL]: 'Change Email',
  [IDS.HELMET_SECTIONTITLE_FORGOTPASSWORD]: 'Forgot Password',
  [IDS.HELMET_SECTIONTITLE_FORGOTUSERNAME]: 'Forgot Username',
  [IDS.HELMET_SECTIONTITLE_REGISTER]: 'Register',
};

const enMurabahaMessages = {
  ...enMessages,
  // Change Email Helmet Page Titles
  [IDS.HELMET_CHANGEEMAIL_PAGETITLE_VERIFY]: 'Verify Account Information',
  // Forgot Username Helmet Page Titles
  [IDS.HELMET_FORGOTUSERNAME_PAGETITLE_VERIFY]: 'Verify Account Information',
  // Register Helmet Page Titles
  [IDS.HELMET_REGISTER_PAGETITLE_LOANNUMBER]: 'Account Number',
};

export const INTL_IDS = IDS;

export default {
  [LANGUAGE_ENGLISH]: enMessages,
  [LANGUAGE_ENGLISH_MURABAHA]: enMurabahaMessages,
};
